module.exports = __webpack_public_path__ + "static/media/gimli.1b6c9982.png";